export var SelectionBoxesCount;
(function (SelectionBoxesCount) {
    SelectionBoxesCount[SelectionBoxesCount["PointBox"] = 3] = "PointBox";
    SelectionBoxesCount[SelectionBoxesCount["TwoBox"] = 2] = "TwoBox";
    SelectionBoxesCount[SelectionBoxesCount["ThreeBox"] = 3] = "ThreeBox";
})(SelectionBoxesCount || (SelectionBoxesCount = {}));
//# sourceMappingURL=SelectionBoxesCount.js.map